import SheetDetailPage from "../features/sheets/SheetDetailPage";

export default function SheetDetailRoute() {
  return <SheetDetailPage />;
}
